import React from "react";
import { ISidebarCardItem } from "src/components/SidebarCard/interface";
import IBaseDTO from "src/Interfaces/baseDTO";
import { IAssociations } from "./Components/Badge/badgeAssociate";
import { IMetba002 } from "./Components/Perspective/interface";


export interface ISidebarCardItemMaps extends ISidebarCardItem{
    permissions: number;
}

export interface IRefMapsModals{
    actionButtonAdd: () => void;
    actionButtonChange: (card: ISidebarCardItem, copy: boolean) => void;
    actionButtonDelete: (card: ISidebarCardItem) => void;
}

export interface IMapsModal{
    cards: ISidebarCardItemMaps[];
    setCards: React.Dispatch<React.SetStateAction<ISidebarCardItemMaps[]>>;
    mapsSubtitle: (dataInit: any, dataFim: any) => string;
    onCallbackDeleteMap: (mapId: number) => void;
    onCallbackMaps: (mapId: number) => void;
}

export interface IMetba008{
    mea008Id: number;
    mea008Efa004Id?: number;
    mea008Efa004Descricao?: string;
    mea008Efa005Nome?: string;
    mea008Efa005Id?: number;
    mea008Permissao: number;
}

export interface IMetba001Form extends IBaseDTO{
    mea001Id: number,
    mea001Nome: string,
	mea001Dtvalini?: Date,
	mea001Dtvalfim?: Date,
	mea001Descricao: string,
	mea001Missao: string,
	mea001Visao: string,
    mea001Notas?: string,
    mea001Politicaqualidade?: string,
    mea001Valores?: string,
    mea001Ativo: "S" | "N",
    mea001Tags: string | string[] | null,
    favorite: boolean,
	metba008?: IMetba008[],
    
}

export interface IMetba001001{
    mea001Id: number,
    mea001Nome: string,
	mea001Dtvalini?: Date,
	mea001Dtvalfim?: Date,
	mea001Descricao: string,
	mea001Missao: string,
	mea001Visao: string,
    mea001Notas?: string,
    mea001Politicaqualidade?: string,
    mea001Valores?: string,
    metba002?: IMetba002[]
    associations?: IAssociations;
    realizedPercentage: number;
    color: string;
    mea008Permissao: number;
}

export interface StyledMapContent{
    openDetails: boolean;
    color: string;
}

export enum MapsHierarchyTypes{
    MAPS = 1,
    PERSPECTIVES = 2,
    OBJECTIVES = 3,
    INICIATIVES = 4,
    INDICATORS = 5
}

export enum ModuleTypes{
    ACTIONS = 1,
    INDICATORS = 2,
    PROJECTS = 3,
    SWOT = 4,
    STRATEGY = 5
}
